import React, { useMemo, useCallback } from 'react';
import Animated from 'react-native-reanimated';
import { SectionList, View } from 'react-native';
import Text from 'design-system/Text';
import { AppView, Indicator, withAnimatedNavigationHeader } from 'design-system';
import { rem, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { createActivitySections } from 'utils/formatting';
import { extractKeyFromKey } from 'utils/flatListHelpers';
import ActivityItem from '../components/ActivityItem';
import useRecurringBuyActivities from '../hooks/useRecurringBuyActivities';
const AnimatedSectionList = Animated.createAnimatedComponent(SectionList);
const renderItem = ({ item }) => (<ActivityItem item={item} withWrapper isFirstInSection={item.isFirstInSection} isLastInSection={item.isLastInSection}/>);
const RecurringBuyActivityScreen = withAnimatedNavigationHeader((props) => {
    const styles = useStyles(styleSet);
    const recurringBuy = props.route.params?.recurringBuy;
    const { activities, onLoadNextPage, loading } = useRecurringBuyActivities(recurringBuy.id);
    const sections = useMemo(() => {
        if (activities) {
            const result = createActivitySections(activities, 'timestamp');
            return result;
        }
        return [];
    }, [activities]);
    const renderSectionHeader = useCallback(({ section }) => (<View style={styles.sectionTitle}>
          <Text Text-16 Secondary>
            {section.title}
          </Text>
        </View>), [styles]);
    const paddingBottom = useMarginBottom('paddingBottom');
    const content = useMemo(() => {
        if (loading && !sections?.length) {
            return <Indicator dark style={styles.indicatorStyle}/>;
        }
        if (sections.length === 0) {
            return null;
        }
        return (<AnimatedSectionList sections={sections} initialNumToRender={30} renderItem={renderItem} scrollEventThrottle={16} style={styles.scrollView} onEndReached={onLoadNextPage} onScroll={props.scrollHandler} stickySectionHeadersEnabled={false} keyExtractor={extractKeyFromKey('id')} renderSectionHeader={renderSectionHeader} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={paddingBottom}/>);
    }, [
        loading,
        sections,
        styles.scrollView,
        styles.indicatorStyle,
        onLoadNextPage,
        props.scrollHandler,
        renderSectionHeader,
        paddingBottom,
    ]);
    return (<AppView style={styles.container}>
        <View style={styles.innerContainer}>{content}</View>
      </AppView>);
}, ({ colors }) => ({
    title: 'History',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styleSet = createStyleSheets(() => ({
    container: {
        flex: 1,
    },
    innerContainer: {
        flex: 1,
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
    },
    scrollView: {
        flex: 1,
    },
    sectionTitle: {
        paddingTop: rem(24),
        paddingBottom: rem(16),
        marginHorizontal: rem(16),
    },
    indicatorStyle: {
        backgroundColor: 'transparent',
    },
}));
export default RecurringBuyActivityScreen;
